import React from "react";
import CheckoutBookingRevenueReport from "./CheckoutbookingrevenuereportTable";

const CheckoutRevenueList = () => {
  return (
    <div className="container-fluid admin-module-page py-4">
      <div className="admin-page-header d-flex justify-content-between align-items-start flex-wrap gap-3 mb-4">
        <div>
          <span className="admin-page-kicker">Hotel Management</span>
          <h3 className="admin-page-title fw-bold mb-1">CheckOut Revenue Report</h3>
          <p className="admin-page-description mb-0">
            View and analyze net booking revenue across properties for the selected date range.
          </p>
        </div>
      </div>

      <div className="card admin-surface-card">
        <div className="card-body admin-surface-body">
          <CheckoutBookingRevenueReport />
        </div>
      </div>
    </div>
  );
};

export default CheckoutRevenueList;
